import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1], delay }}
    className="w-full rounded-3xl border border-gray-200 bg-white shadow-sm p-8 lg:p-10"
  >
    {children}
  </motion.div>
);

const TermsOfService = () => {
  return (
    <main className="min-h-screen bg-white text-gray-900">
      {/* Distinct Prominent Hero: diagonal bands with parallax dots */}
      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 pointer-events-none">
          {/* Mesh-like motion graphics in alternate corners */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            transition={{ duration: 1 }}
            className="absolute -top-24 -left-24 w-[900px] h-[900px]"
          >
            <motion.div animate={{ rotate: 360 }} transition={{ duration: 40, repeat: Infinity, ease: 'linear' }} className="w-full h-full">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <motion.circle cx="20" cy="20" r="1.6" fill="#3b82f6" opacity="0.85" />
                <motion.circle cx="80" cy="20" r="1.6" fill="#10b981" opacity="0.85" />
                <motion.circle cx="20" cy="80" r="1.6" fill="#f59e0b" opacity="0.85" />
                <motion.circle cx="80" cy="80" r="1.6" fill="#ef4444" opacity="0.85" />
                <motion.circle cx="35" cy="35" r="1.2" fill="#3b82f6" opacity="0.8" />
                <motion.circle cx="65" cy="35" r="1.2" fill="#10b981" opacity="0.8" />
                <motion.circle cx="35" cy="65" r="1.2" fill="#f59e0b" opacity="0.8" />
                <motion.circle cx="65" cy="65" r="1.2" fill="#ef4444" opacity="0.8" />
                <motion.line x1="20" y1="20" x2="80" y2="20" stroke="#60a5fa" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="80" x2="80" y2="80" stroke="#fbbf24" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="20" x2="20" y2="80" stroke="#a78bfa" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="20" x2="80" y2="80" stroke="#34d399" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2.4, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="35" x2="65" y2="35" stroke="#60a5fa" strokeWidth="0.2" opacity="0.4" animate={{ opacity: [0.15, 0.55, 0.15] }} transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="65" x2="65" y2="65" stroke="#f87171" strokeWidth="0.2" opacity="0.4" animate={{ opacity: [0.15, 0.55, 0.15] }} transition={{ duration: 1.9, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="35" x2="35" y2="65" stroke="#34d399" strokeWidth="0.2" opacity="0.35" animate={{ opacity: [0.15, 0.5, 0.15] }} transition={{ duration: 1.7, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="65" y1="35" x2="65" y2="65" stroke="#f59e0b" strokeWidth="0.2" opacity="0.35" animate={{ opacity: [0.15, 0.5, 0.15] }} transition={{ duration: 2.1, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="20" x2="65" y2="65" stroke="#93c5fd" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="20" x2="35" y2="65" stroke="#6ee7b7" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.0, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="80" x2="65" y2="35" stroke="#fde68a" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.4, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="80" x2="35" y2="35" stroke="#fca5a5" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }} />
              </svg>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            transition={{ duration: 1 }}
            className="absolute -bottom-24 -right-24 w-[900px] h-[900px]"
          >
            <motion.div animate={{ rotate: -360 }} transition={{ duration: 40, repeat: Infinity, ease: 'linear' }} className="w-full h-full">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <motion.circle cx="20" cy="20" r="1.6" fill="#3b82f6" opacity="0.85" />
                <motion.circle cx="80" cy="20" r="1.6" fill="#10b981" opacity="0.85" />
                <motion.circle cx="20" cy="80" r="1.6" fill="#f59e0b" opacity="0.85" />
                <motion.circle cx="80" cy="80" r="1.6" fill="#ef4444" opacity="0.85" />
                <motion.circle cx="35" cy="35" r="1.2" fill="#3b82f6" opacity="0.8" />
                <motion.circle cx="65" cy="35" r="1.2" fill="#10b981" opacity="0.8" />
                <motion.circle cx="35" cy="65" r="1.2" fill="#f59e0b" opacity="0.8" />
                <motion.circle cx="65" cy="65" r="1.2" fill="#ef4444" opacity="0.8" />
                <motion.line x1="20" y1="20" x2="80" y2="20" stroke="#60a5fa" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="80" x2="80" y2="80" stroke="#fbbf24" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="20" x2="20" y2="80" stroke="#a78bfa" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="20" x2="80" y2="80" stroke="#34d399" strokeWidth="0.25" opacity="0.35" animate={{ opacity: [0.2, 0.6, 0.2] }} transition={{ duration: 2.4, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="35" x2="65" y2="35" stroke="#60a5fa" strokeWidth="0.2" opacity="0.4" animate={{ opacity: [0.15, 0.55, 0.15] }} transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="65" x2="65" y2="65" stroke="#f87171" strokeWidth="0.2" opacity="0.4" animate={{ opacity: [0.15, 0.55, 0.15] }} transition={{ duration: 1.9, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="35" y1="35" x2="35" y2="65" stroke="#34d399" strokeWidth="0.2" opacity="0.35" animate={{ opacity: [0.15, 0.5, 0.15] }} transition={{ duration: 1.7, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="65" y1="35" x2="65" y2="65" stroke="#f59e0b" strokeWidth="0.2" opacity="0.35" animate={{ opacity: [0.15, 0.5, 0.15] }} transition={{ duration: 2.1, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="20" x2="65" y2="65" stroke="#93c5fd" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="20" x2="35" y2="65" stroke="#6ee7b7" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.0, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="20" y1="80" x2="65" y2="35" stroke="#fde68a" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 3.4, repeat: Infinity, ease: 'easeInOut' }} />
                <motion.line x1="80" y1="80" x2="35" y2="35" stroke="#fca5a5" strokeWidth="0.15" opacity="0.25" animate={{ opacity: [0.08, 0.3, 0.08] }} transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }} />
              </svg>
            </motion.div>
          </motion.div>
        </div>

        <div className="container-custom py-24 lg:py-32 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-center"
          >
            <h1 className="text-4xl lg:text-6xl font-bold font-slim tracking-tight">Terms of Service — FlowMatic</h1>
            <p className="mt-4 text-lg text-gray-600">Last Updated: October 2025</p>
          </motion.div>
        </div>
      </section>

      <section className="container-custom py-16 lg:py-20">
        <div className="max-w-5xl mx-auto space-y-8">
          <Card>
            <p className="text-lg leading-relaxed text-gray-700">
              Welcome to FlowMatic. These Terms of Service (“Terms”) govern your use of our website, products, and AI automation services (collectively, the “Services”). By accessing or using our Services, you agree to comply with and be bound by these Terms. If you do not agree, please discontinue use immediately.
            </p>
          </Card>

          <Card delay={0.05}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">About FlowMatic</span>
            </h2>
            <p className="text-gray-700">
              FlowMatic builds and deploys custom AI agents, automation systems, and intelligent workflows to help companies streamline their operations. These Terms apply to all users of our Services, including clients, visitors, and partners.
            </p>
          </Card>

          <Card delay={0.1}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Use of Services</span>
            </h2>
            <p className="text-gray-700 mb-3">You agree to use our Services only for lawful purposes and in compliance with all applicable laws and regulations.</p>
            <p className="text-gray-700">You must not:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-2">
              <li>Use our AI agents or automations for illegal, harmful, or deceptive activities.</li>
              <li>Interfere with the security or functionality of our systems.</li>
              <li>Reverse-engineer, resell, or modify our technology without written permission.</li>
            </ul>
            <p className="text-gray-700 mt-3">FlowMatic reserves the right to suspend or terminate access if we detect misuse or unauthorized activity.</p>
          </Card>

          <Card delay={0.15}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Account Registration</span>
            </h2>
            <p className="text-gray-700 mb-3">When you create an account or sign up for our services, you must:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Provide accurate and complete information.</li>
              <li>Maintain the confidentiality of your credentials.</li>
              <li>Immediately notify us of unauthorized access or security issues.</li>
            </ul>
            <p className="text-gray-700 mt-3">FlowMatic is not liable for losses caused by your failure to secure your login information.</p>
          </Card>

          <Card delay={0.2}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Payment and Billing</span>
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Payment terms are defined in the client proposal, invoice, or subscription agreement.</li>
              <li>All payments must be made in full before project handover unless otherwise stated.</li>
              <li>Late payments may result in service suspension or delay in deployment.</li>
              <li>Fees are non-refundable once a project or automation is delivered.</li>
            </ul>
          </Card>

          <Card delay={0.25}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Intellectual Property Rights</span>
            </h2>
            <p className="text-gray-700">
              All software, AI models, automation frameworks, designs, and documentation created by FlowMatic remain the intellectual property of FlowMatic unless explicitly transferred in writing. Clients are granted a limited, non-transferable license to use delivered AI agents or automations for their own business purposes only.
            </p>
          </Card>

          <Card delay={0.3}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Client Data</span>
            </h2>
            <p className="text-gray-700 mb-2">We respect your ownership of your data. By using our Services, you grant us permission to:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Access and process necessary data solely to configure and operate your automations.</li>
              <li>Store minimal operational data as required for service functionality.</li>
            </ul>
            <p className="text-gray-700 mt-3">We do not sell or share client data with third parties without consent. For details, refer to our Privacy Policy.</p>
          </Card>

          <Card delay={0.35}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Service Modifications</span>
            </h2>
            <p className="text-gray-700">We may update, modify, or discontinue certain features to improve performance or comply with new technologies. Whenever possible, clients will be notified in advance of major service changes.</p>
          </Card>

          <Card delay={0.4}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Limitation of Liability</span>
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Any indirect, incidental, or consequential damages arising from the use of our Services.</li>
              <li>Downtime, data loss, or third-party system failures beyond our control.</li>
            </ul>
            <p className="text-gray-700 mt-3">Our total liability under these Terms shall not exceed the total amount paid by you for the Services within the last 12 months.</p>
          </Card>

          <Card delay={0.45}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Warranties Disclaimer</span>
            </h2>
            <p className="text-gray-700">All services are provided “as is” without warranties of any kind, whether express or implied. We do not guarantee uninterrupted operation, error-free performance, or compatibility with all third-party platforms.</p>
          </Card>

          <Card delay={0.5}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Termination</span>
            </h2>
            <p className="text-gray-700 mb-2">You may terminate your service agreement at any time by written notice. FlowMatic reserves the right to terminate or suspend access if you:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Breach these Terms</li>
              <li>Engage in misuse</li>
              <li>Fail to make timely payments</li>
            </ul>
            <p className="text-gray-700 mt-3">Upon termination, all licenses granted to you will immediately expire.</p>
          </Card>

          <Card delay={0.55}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Governing Law</span>
            </h2>
            <p className="text-gray-700">These Terms are governed by and interpreted in accordance with the laws of Pakistan, without regard to conflict of law principles. Any disputes shall be resolved in the competent courts of Faisalabad, Pakistan.</p>
          </Card>

          <Card delay={0.6}>
            <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-center">
              <span className="inline-block px-8 py-2 rounded-2xl bg-gradient-to-r from-gray-300/30 via-gray-400/30 to-gray-300/30 shadow-sm">Contact Us</span>
            </h2>
            <p className="text-gray-700">For any questions or concerns regarding these Terms, please contact us:</p>
            <p className="mt-2 font-medium">support@flowmatic.com</p>
            <a href="https://www.flowmatic.com" target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-blue-600 hover:text-purple-600 transition-colors">www.flowmatic.com</a>
          </Card>
        </div>
      </section>
    </main>
  );
};

export default TermsOfService;


